
















import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Mutation } from "vuex-class";
import { project } from "../board";
import moment from "moment";

@Component
export default class ProjectCard extends Vue {
  @Action private updateProject;
  @Action private setCurrentProject;
  @Prop() project!: project;
  @Mutation setSelectedProject;
  @Mutation setBoards;
  private cardEdit = false;

  get projectDescription() {
    return this.project._id + "-desc";
  }

  get cardDate() {
    if (this.project.createdOn) {
      const formattedDate = moment(this.project.createdOn.toString()).format(
        "MMM DD, YYYY"
      );
      return formattedDate;
    }
    return "";
  }
  public selectProject() {
    this.setBoards(this.project.boards);
    this.setSelectedProject(this.project);
    this.setCurrentProject();
    this.$router.push({ path: "/project" });
  }

  public toggleCardEdit() {
    this.cardEdit = !this.cardEdit;
    if (this.cardEdit) {
      this.$nextTick(() => {
        const projDescElem = document.getElementById(this.projectDescription);
        if (projDescElem) {
          projDescElem.focus();
        }
      });
    }
  }

  public saveCard() {
    this.updateProject(this.project);
    this.toggleCardEdit();
  }
}
